import { render, staticRenderFns } from "./Serasa.vue?vue&type=template&id=94e46a40"
import script from "./Serasa.vue?vue&type=script&lang=js"
export * from "./Serasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports